App.modules['lang-split'] = (root) => {
  // ===== 옵션: data-watch 또는 data-lang-watch 둘 다 허용 =====
  const USE_MUTATION_OBSERVER = root.hasAttribute('data-watch') || root.hasAttribute('data-lang-watch');
  let observer = null;

  // ===== 유틸 =====
  const isEN = ch => /[A-Za-z]/.test(ch);
  const isJA = ch => /[\u3040-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFF66-\uFF9F]/.test(ch);

  function splitTextNode(node) {
    const text = node.nodeValue;
    if (!text || !text.trim()) return null;
    const runs = [];
    let buf = '', mode = null;
    const flush = () => { if (buf) { runs.push({ text: buf, mode }); buf=''; } };

    for (let i=0; i<text.length; i++){
      const ch = text[i];
      const en = isEN(ch), ja = isJA(ch);
      if (!en && !ja) { buf += ch; continue; }
      const next = en ? 'en' : 'ja';
      if (mode === next || mode === null) { mode = next; buf += ch; }
      else { flush(); mode = next; buf = ch; }
    }
    flush();

    const frag = document.createDocumentFragment();
    for (const r of runs) {
      if (!r.mode) { frag.appendChild(document.createTextNode(r.text)); continue; }
      const span = document.createElement('span');
      span.className = `seg--${r.mode}`;
      span.textContent = r.text;
      frag.appendChild(span);
    }
    return frag;
  }

  function segmentElement(el) {
    if (el.dataset.langProcessed === '1') return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (n.parentElement && n.parentElement.matches('.seg--en, .seg--ja')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const toReplace = [];
    for (let n; (n = walker.nextNode());) toReplace.push(n);
    toReplace.forEach(tn => {
      const frag = splitTextNode(tn);
      if (frag) tn.parentNode.replaceChild(frag, tn);
    });
    el.dataset.langProcessed = '1';
  }

  const getInnerTextRoot = (el) => el.querySelector(':scope > [data-pf-type="Text"]') || null;

  function wrapLines(container) {
    if (container.dataset.lineWrapped === '1') return;
    const rootNode = getInnerTextRoot(container) || container;

    const frag = document.createDocumentFragment();
    let line = document.createElement('div');
    line.className = 'langline';

    const nodes = Array.from(rootNode.childNodes);
    nodes.forEach(node => {
      if (node.nodeName === 'BR') {
        if (line.childNodes.length) frag.appendChild(line);
        line = document.createElement('div');
        line.className = 'langline';
        node.remove();
      } else {
        line.appendChild(node);
      }
    });
    if (line.childNodes.length) frag.appendChild(line);

    rootNode.textContent = '';
    rootNode.appendChild(frag);
    container.dataset.lineWrapped = '1';
  }

  function processHost(host) {
    segmentElement(host);
    const inner = getInnerTextRoot(host) || host;
    segmentElement(inner);
    wrapLines(host);
  }

  function applyAll(scope) {
    const sel = "[data-mount='lang-split']";
    const hosts = scope.matches && scope.matches(sel)
      ? [scope]
      : Array.from(scope.querySelectorAll(sel));
    hosts.forEach(processHost);
  }

  function resetHost(el) {
    delete el.dataset.langProcessed;
    delete el.dataset.lineWrapped;
    const inner = getInnerTextRoot(el) || el;
    inner.querySelectorAll('.seg--en, .seg--ja').forEach(s => {
      s.replaceWith(document.createTextNode(s.textContent));
    });
    // langline 해제는 상황에 따라 유지하는 것이 자연스러워 생략
  }

  function init() {
    applyAll(root);

    if (USE_MUTATION_OBSERVER) {
      observer = new MutationObserver(muts => {
        const need = muts.some(m => (m.type === 'childList' || m.type === 'characterData'));
        if (need) {
          const sel = "[data-mount='lang-split']";
          const hosts = root.matches && root.matches(sel)
            ? [root]
            : Array.from(root.querySelectorAll(sel));
          hosts.forEach(resetHost);
          applyAll(root);
        }
      });
      observer.observe(root, { subtree: true, childList: true, characterData: true });
    }
  }

  function destroy() {
    if (observer) { observer.disconnect(); observer = null; }
  }

  return { init, destroy };
};
